import { styled } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ReactComponent as ArrowRight } from 'assets/icons/ic-arrow-right.svg';

export const Container = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
  '& a:last-child': {
    color: theme.palette.xpl.text.primary,
  },
  '& svg': {
    color: theme.palette.xpl.dm.text.secondary,
  },
}));

export const LinkContainer = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.xpl.text.secondary,
}));

export const ArrowRightIcon = styled(ArrowRight)(({ theme }) => ({
  margin: '0 20px',
  color: theme.palette.xpl.text.secondary,
}));
